/* Shopify's privacy banner text cannot be edited in the admin. This swaps the
   German description for a shorter one that also names the right to withdraw
   consent (TDDDG/DSGVO). Shopify's policy link is kept as is. Other languages
   keep Shopify's own text. If Shopify changes the banner markup, nothing
   breaks: the original text simply stays. */
(function () {
  if (!/^de/i.test(document.documentElement.lang || '')) return;

  var TEXT = 'Wir und unsere Partner (u. a. Shopify) nutzen Cookies für Personalisierung, Werbung und Analyse, nur mit deiner Zustimmung. Du kannst sie jederzeit widerrufen. Mehr in der ';

  function shorten() {
    var link = document.getElementById('shopify-pc__banner__body-policy-link');
    var paragraph = link && link.parentNode;
    if (!paragraph || paragraph.tagName !== 'P') return false;
    while (paragraph.firstChild && paragraph.firstChild !== link) paragraph.removeChild(paragraph.firstChild);
    paragraph.insertBefore(document.createTextNode(TEXT), link);
    if (!link.nextSibling) paragraph.appendChild(document.createTextNode('.'));
    return true;
  }

  if (shorten()) return;
  var observer = new MutationObserver(function () {
    if (shorten()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
  // The banner only shows on first visit; stop watching the DOM after a while.
  setTimeout(function () { observer.disconnect(); }, 15000);
})();
